import axios from 'axios';
export { apiErrorMessage } from './alianzasApi';

const api = axios.create({
  baseURL: `${(process.env.REACT_APP_API_URL || '/api').replace(/\/$/, '')}/servicios-profesionales/reporte-semanal`,
  timeout: 45000,
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use((response) => response, (error) => {
  if (error?.response?.status === 401) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
    if (window.location.pathname !== '/login') window.location.assign('/login');
  }
  return Promise.reject(error);
});

export const weeklyReportApi = {
  schema: () => api.get('/schema').then((r) => r.data),
  options: () => api.get('/options').then((r) => r.data),
  records: (kind, params) => api.get(`/records/${kind}`, { params }).then((r) => r.data),
  create: (kind, data) => api.post(`/records/${kind}`, data).then((r) => r.data),
  update: (kind, id, data, revision) => api.put(`/records/${kind}/${id}`, data, { params: { revision } }).then((r) => r.data),
  remove: (kind, id, revision) => api.delete(`/records/${kind}/${id}`, { params: { revision } }).then((r) => r.data),
  dashboard: (params) => api.get('/dashboard', { params }).then((r) => r.data),
};
